import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import WhitePortlet from '../utils/WhitePortlet';
import i18next from 'i18next';
import UserDetails from './../users/UserDetails';
import * as blockUtils from './../../utils/BlockUtils';
import * as usersApi from './../../api/users-api';
import EditOwnUserForm from '../users/EditOwnUserForm';
import * as viewUtils from './../../utils/view-utils';
import EditPasswordForm from '../users/EditPasswordForm';
import SiteAccessForm from '../users/site_access/SiteAccessForm';

class ProfileDetailsContainer extends Component {
  constructor(props) {
    super(props);

    this.userFormDialogId = 'userFormDialog';
    this.siteAccessFormDialogId = 'siteAccessFormDialogId';

    this.addAllSitesToUser = this.addAllSitesToUser.bind(this);
  }

  componentDidMount() {
    blockUtils.blockUI();
    usersApi.getUserProfile();
  }

  UNSAFE_componentWillUpdate() {
    blockUtils.unblockUI();
  }

  componentDidUpdate() {
    if (this.props.error && this.modalDialog) {
      this.modalDialog.handleError(this.props.error);
      blockUtils.unblockUI();
    } else {
      $(`#${this.userFormDialogId}`).modal('hide');
    }
  }

  showEditPasswordForm() {
    const props = {
      dialogId: 'edit-password-dialog',
      error: this.props.error,
      user: this.props.userProfile,
    };
    this.modalDialog = viewUtils.showModal(EditPasswordForm, props.dialogId, props);
  }

  showSiteAccessForm() {
    const props = {
      dialogId: this.siteAccessFormDialogId,
      user: this.props.userProfile,
      onCloseClick: () => usersApi.refreshUserProfile(this.props.userProfile.id),
    };
    this.modalDialog = viewUtils.showModal(SiteAccessForm, this.siteAccessFormDialogId, props);
  }

  showUserForm() {
    const props = {
      dialogId: this.userFormDialogId,
      error: this.props.error,
      user: this.props.userProfile,
    };
    this.modalDialog = viewUtils.showModal(EditOwnUserForm, this.userFormDialogId, props);
  }

  addAllSitesToUser() {
    blockUtils.blockUI();
    usersApi.addAllSitesToUser(this.props.userProfile.id).then((response) => {
      if (response.status !== 200) {
        window.showAlert(i18next.t('error'), response.statusText);
      }

      usersApi.refreshUserProfile(this.props.userProfile.id);
      blockUtils.unblockUI();
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), viewUtils.getErrorDescription(error));
    });
  }

  render() {
    return (
      <WhitePortlet caption={i18next.t('profile.my_profile')} icon="icon-user">
        <UserDetails presentedUser={this.props.userProfile}/>
        <a className="btn btn-info" data-toggle="modal" onClick={() => this.showUserForm()}>{i18next.t('links.edit')}</a>
        <a className="btn btn-info" style={{marginLeft: '20px'}} onClick={() => this.addAllSitesToUser()}>{i18next.t('links.addAllSitesToUser')}</a>
        <a className="btn btn-info" style={{marginLeft: '20px'}} onClick={() => this.showEditPasswordForm()}>{i18next.t('users.edit_password')}</a>
        <a className="btn btn-info" style={{marginLeft: '20px'}} onClick={() => this.showSiteAccessForm()}>{i18next.t('sites.site_management.user_site_menu')}</a>
      </WhitePortlet>
    );
  }
}

ProfileDetailsContainer.propTypes = {
  userProfile: PropTypes.object,
  error: PropTypes.any,
};
ProfileDetailsContainer.defaultProps = {};

const mapStateToProps = function(store) {
  return {
    userProfile: store.usersState.userProfile,
  };
};

export default connect(mapStateToProps)(ProfileDetailsContainer);
